var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-body-user-info" }, [
    _c("div", { staticClass: "description" }, [
      _vm._v("\n    Add a new validator by entering the information below.\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Name:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.validatorInfo.name,
              expression: "validatorInfo.name"
            }
          ],
          staticClass: "input",
          attrs: { type: "text", placeholder: "Name" },
          domProps: { value: _vm.validatorInfo.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.validatorInfo, "name", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "name row" }, [
      _c("div", { staticClass: "first-name" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Field:")]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.validatorInfo.field,
                expression: "validatorInfo.field"
              }
            ],
            staticClass: "input",
            attrs: {
              type: "text",
              placeholder: "enum.validator.field.last_name",
              disabled: true
            },
            domProps: { value: _vm.validatorInfo.field },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.validatorInfo, "field", $event.target.value)
              }
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f6ccc1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f6ccc1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/globalSettings/AddValidator.vue
// module id = 1429
// module chunks = 1